import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturingAssemblyDetailsPage } from '@/areas/manufacturing-scenarios/ManufacturingScenarios/ManufacturingAssemblyDetails/ManufacturingAssemblyDetailsPage';
import { canViewProjectManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/',
)({
    staticData: { access: { permissions: canViewProjectManufacturing }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <ManufacturingAssemblyDetailsPage
            rfqId={pathParams.projectId}
            manufacturingAssemblyDetailsId={pathParams.manufacturingAssemblyDetailsId}
        />
    );
}
